import React from 'react';
import AudioViewer from '../viewer/audio-viewer.js';
import 'ricos-context';
import '../audio.rtlignore-fad433f7.js';
import '../style-inject.es-e7b07dd7.js';
import '../consts.js';
import 'ricos-types';
import '../dataHooks.js';
import '../ReactPlayerWrapper.js';
import 'classnames';
import 'lodash';
import 'wix-react-player';
import 'wix-rich-content-ui-components';
import '../components/AudioImage.js';
import 'wix-rich-content-common/libs/imageUtils';
import '../components/AudioDetails.js';
import '../components/AudioActionIcons.js';
import 'ricos-content';
import '../components/SoundControl.js';
import '../components/ContextMenu.js';
import 'wix-rich-content-editor-common';
import '../components/DropdownMenu.js';
import '../components/AudioDuration.js';
import '../viewer/audio-embed-viewer.js';
import 'wix-rich-content-common';
import 'wix-rich-content-plugin-html/libs/HtmlComponent';

const Audio = ({
  settings,
  componentData,
  node,
  updateAttributes
}) => {
  const { loading, id } = node.attrs;
  return /* @__PURE__ */ React.createElement(
    AudioViewer,
    {
      componentData,
      updateAttributes,
      nodeId: id,
      settings,
      isLoading: loading
    }
  );
};

export { Audio };
//# sourceMappingURL=component.js.map
